//首页接口
import axios from '../common/js/axios'
import { host } from '../common/js/config'

/*示例*/
export function getHomeData(data) {
	const url = `${host}/app/valueadded/courseinfo`
	return axios({
		url: url,
		params: data
	})
}


const COLLEGETYPE = '/app/collegeProTypeList'
// 课程列表
const COURSELIST = '/app/college/queryCourseList'// '/app/college/courseList'
// 热门课程
const HOTCOURSELIST = '/app/college/queryHotCourseList'

// 多章节课程详情页
const COURSESDETAIL = '/app/valueadded/courseinfo'
// 章节
const COURSECHAPTER = '/app/valueadded/coursechapter'
// 课程分类
const COURSETYPE = '/app/college/websiteCourseList'
// 评论列表
const COMMENT = '/app/course/comment/list'
// 我的课程
const MYLESIION = '/app/uc/course'
//申请证书
const APPLYCERT = '/app/uc/addCourseCert'
// 收藏
const COLLECT = '/app/course/addfavorites'
// 取消收藏
const DEL_COLLECT = '/app/collection/cleanFavorites'
// 评论点赞
const COMMENTGOOD = '/app/course/commentpraise'
// 首页接口
const HOMELIST = '/app/college/queryCollegeProperty'
// 获取笔记接口
const NOTE = '/app/course/note/list'
// 获取问答接口
const QUESTION = '/app/course/question/list'
// 视频播放时间
const VIDEOTIME = '/app/valueadded/addloglearn'
// 购买免费课程
const BUYFREE = '/app/order/buyFreeCourse'
// 添加积分
const INTEGRAL = '/app/userCollegeIntegral/add'

//获取outer视频
const OUTERVIDEO = '/app/kpoint/outerUrl'               

//免密登录
const FREELOGIN = '/app/user/noPwdLogin'
// 获取首页信息
export function getHomeList(data) {
	return axios({
		url: HOMELIST,
		data: data,
		method: "POST"
	})
}

// 评论点赞
export function getCommentGood(data) {
	return axios({
		url: COMMENTGOOD,
		params: data,
		method: "GET"
	})
}

// 取消收藏

export function DelCollect(data) {
	return axios({
		url: DEL_COLLECT,
		params: data,
		method: "GET"
	})
}

// 收藏
export function getCollect(data) {
	return axios({
		url: COLLECT,
		params: data,
		method: "GET"
	})
}

//笔记
export function getNote(data) {
	return axios({
		url: NOTE,
		params: data,
		method: "GET"
	})
}

//问答
export function getQuestion(data) {
	return axios({
		url: QUESTION,
		params: data,
		method: "GET"
	})
}
//视频播放时间
export function getVideoTime(data) {
	return axios({
		url: VIDEOTIME,
		params: data,
		method: "GET"
	})
}
//购买免费课程
export function getBuyfree(data) {
	return axios({
		url: BUYFREE,
		params: data,
		method: "GET"
	})
}

// 获取课程大分类
export function getCollegeType(data) {
	return axios({
		url: COLLEGETYPE,
		params: data,
		method: "GET"
	})
}
// 获取课程数据
export function getCourseList(data) {
	return axios({
		url: COURSELIST,
		params: data,
		method: "GET"
	})
}
// 获取热门课程
export function getHotList(data) {
	return axios({
		url: HOTCOURSELIST,
		params: data,
		method: "GET"
	})
}

//课程详情
export function getCoursesDetail(data) {
	return axios({
		url: COURSESDETAIL,
		params: data,
		method: "GET"
	})
}
//课程详情 速度优化
export function getCoursesDetailSpeedup(data) {
	return axios({
		url: '/app/member/courseinfo',
		params: data,
		method: "GET"
	})
}
// 章节
export function getCourseChapter(data) {
	return axios({
		url: COURSECHAPTER,
		params: data,
		method: "GET"
	})
}

// 章节  优化
export function getCourseChapterSpeedup(data) {
	return axios({
		url: '/app/member/coursechapter',
		params: data,
		method: "GET"
	})
}
// 课程分类
export function getCourseType(data) {
	return axios({
		url: COURSETYPE,
		params: data,
		method: "GET"
	})
}

// 评论列表
export function getComment(data) {
	return axios({
		url: COMMENT,
		params: data,
		method: "GET"
	})
}
// 我的课程列表
export function getMyLession(data) {
	return axios({
		url: MYLESIION,
		params: data,
		method: "GET"
	})
}
//申请证书
export function applycert(data) {
	return axios({
		url: APPLYCERT,
		params: data,
		method: "GET"
	})
}
// 添加积分
export function addIntegralOper(data) {
	return axios({
		url: INTEGRAL,
		params: data,
		method: "GET"
	})
}

// OUTER视频
export function getOuterVideo(data) {
	return axios({
		url: OUTERVIDEO,
		params: data,
		method: "GET"
	})
}

//获取微官网 图片
export function homeImages(data){
	const url = `${host}/app/wxWebsite/homeImages`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//微官网导航栏
export function navigateList(data){
	const url = `${host}/app/wxWebsite/navigateList`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//微官网导航栏详情
export function navigateDetail(data){
	const url = `${host}/app/wxWebsite/navigateDetail`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//微官网资讯列表  //微官网立即报名
export function contentList(data){
	const url = `${host}/app/wxWebsite/contentList`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//微官网资讯列表  //微官网立即报名
export function contactUs(data){
	const url = `${host}/app/wxWebsite/contactUs`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//微官网资讯详情切换上一篇下一篇
export function contentDetail(data){
	const url = `${host}/app/wxWebsite/contentDetail`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}
export function wxWebsiteConf(data){
	const url = `${host}/app/wxWebsite/conf`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}


export function wxWebsiteGroupQrcode(data){
	const url = `${host}/app/wxWebsite/groupQrcode`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

export function wxWebsitejoinGroup(data){
	const url = `${host}/app/wxWebsite/joinGroup`
	return axios({
		url:url,
		params: data,
		method: "GET"
	})	
}

//免密登陆
export function freeLogin(data) {
	return axios({
		url: FREELOGIN,
		data: data,
		method: "POST"
	})
}

//vip 会员
export function getUserRecord(data) {
	return axios({
		url: '/app/member/userRecord',
		params: data
	})
}
//vip会员课程列表
export function getMemberCourseList(data) {
	return axios({
		url: '/app/member/memberCourseList',
		params: data
	})
}

//vip会员类型列表接口
export function getTypeList(data) {
	return axios({
		url: '/app/member/typeList',
		params: data
	})
}

//vip学习记录汇总数据接口
export function memberCourseStudyTotal(data) {
	return axios({
		url: '/app/member/memberCourseStudyTotal',
		params: data
	})
}

//vip学习记录分页数据接口
export function memberCourseStudyList(data) {
	return axios({
		url: '/app/member/memberCourseStudyList',
		params: data
	})
}


// WEBPACK FOOTER //
// ./src/api/home.js